module.exports = __webpack_public_path__ + "img/christian_dupont.aaa3ce95.jpeg";